<template>
    <span>
        <img title="Transmitindo normalmente" v-if="corDoIcone === 'verde'" :src="'/assets/img/icons/satelite_verde.png'" style="height: 50px; width: 50px">
        <img title="Sem transmitir a mais de 6 horas" v-else-if="corDoIcone === 'vermelho'" :src="'/assets/img/icons/satelite_vermelho.png'" style="height: 50px; width: 50px">
        <img title="Sem transmitir a mais de 48 horas" v-else-if="corDoIcone === 'preto'" :src="'/assets/img/icons/satelite_preto.png'" style="height: 50px; width: 50px">
        <img title="Sem transmitir a mais de 2 horas" v-else-if="corDoIcone === 'laranja'" :src="'/assets/img/icons/satelite_laranja.png'" style="height: 50px; width: 50px">
        <img title="Sem transmitir a mais de 1 hora" v-else :src="'/assets/img/icons/satelite_amarelo.png'" style="height: 50px; width: 50px">
    </span>
</template>

<script>
export default {
    name: 'IconSateliteTransmissao',
    props: {
        data: {
            default: null
        }
    },
    computed: {
        corDoIcone () {
            if (! this.data) {
                return 'verde'
            }

            let now = moment();
            let dif = now.diff(moment(this.data), 'hour');

            if (dif < 1) {
                return 'verde';
            }

            if (dif < 2) {
                return 'amarelo';
            }

            if (dif < 6) {
                return 'laranja';
            }

            if (dif < 48) {
                return 'vermelho';
            }

            return 'preto';

        }
    }
};
</script>

<style scoped>

</style>
